
import {
    GET_TEL_ACTION_TYPE,
    TEL_CLEAR_ACTION_TYPE,
} from '../sagas/tel';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    tel: null
};

export function getTelInfo(state) {
    return state.tel;
}

function processActionResult(state, action) {
    switch (action.data.result.operation) {
        case GET_TEL_ACTION_TYPE.DEFAULT:
            return {
                tel: action.data.result.result
            };
        default:
            return {};
    }
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_TEL_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case TEL_CLEAR_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_TEL_ACTION_TYPE.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                    ...processActionResult(state, action)
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
